import { HeroUIProvider } from "@heroui/react";
import type React from "react";

export function Providers({ children }: { children: React.ReactNode }) {
	return <HeroUIProvider>{children}</HeroUIProvider>;
}
